import React, { useState, useContext, useMemo } from "react";
import { OntologyContext } from "../../../../utilities/contexts/OntologyContext";
import { ECLLoader } from "../../../index";
import { v4 } from "uuid";
import FormWrapper from "./ECLFormWrapper";

export default function ECLFormBlock(props) {
   // Grab the ontology context
   const ontologyObj = useContext(OntologyContext);

   if (!ontologyObj) {
      return <ECLLoader />;
   }
   //take an existing object, and for each property that is a link UUID, map out that object
   function expandObjectLinks(object, root = true) {
      object.properties.forEach((o) => {
         //internalID is used to create a unique ID for each object on form, using name and index, and the name and index of the parent.
         //Since Objects won't change much behind the scenes, this should be fine
         o.internalID = v4();
         o.root = root;
         if (o.link && typeof o.link != "object") {
            if (o.link === "4BHHB2KHCCAN7VNQ21C27CY3ZX") {
               //Hardcoded Data_assets ULID
               o.link = {
                  UUID: "a4a3a24e-c90b-37f1-2517-6a69a27580cb",
                  ULID: "4BHHB2KHCCAN7VNQ21C27CY3ZX",
                  name: "Image",
                  properties: [
                     {
                        UUID: "a4a3a24e-c90b-37f1-2517-6a69a27580cb",
                        ULID: "4BHHB2KHCCAN7VNQ21C27CY3ZX",
                        name: "Image",
                        type: {
                           name: "image",
                           primitive: "image",
                           description: "",
                        },
                        link: false,
                     },
                  ],
               };
            } else {
               o.link = ontologyObj.objects.find((p) => p.ULID === o.link);
               expandObjectLinks(o.link, false);
            }
         }
      });
   }
   // This state is used for the form when an ontolgy is selected
   const form = useMemo(() => {
      //clone the object from ontology so we're not expanding object links on the ontology context object itself
      const objectDefinition = structuredClone(
         ontologyObj.objects.find(
            (o) => o.UUID === props.block.data.object_type_id,
         ),
      );
      expandObjectLinks(objectDefinition);
      return objectDefinition;
   }, []);

   //Populate link arrays takes our expanded links, and flattens the state we'll use to track how many instances of a link
   //we render
   function populateLinkArrays(object, parent_instance) {
      let newLinkArray = [];
      //turn the recursive object into a recursive list
      object.properties.forEach((o) => {
         if (o.link) {
            const initialInstance = v4();
            newLinkArray.push({
               instances: [initialInstance],
               parent: parent_instance ? parent_instance : o.internalID,
               root: parent_instance ? false : true,
               selectState: o.ownsData ? undefined : [],
               queryable: o.link.name,
               displayProperty: o.link.displayProperty?.[0],
            });
            newLinkArray.push(populateLinkArrays(o.link, initialInstance));
         }
      });
      //Flatten it, since we do this so we don't have to try to map out the correct set state for the recursive form elements
      return newLinkArray.flat(Infinity);
   }
   const [linkArrays, setLinkArrays] = useState(() => {
      return populateLinkArrays(form);
   });

   if (!form || !linkArrays) {
      return <ECLLoader />;
   }

   return (
      <div>
         <label style={{ marginLeft: "5px" }}>{props.block.data.name}</label>
         <FormWrapper
            form={form}
            links={linkArrays}
            setLinks={setLinkArrays}
            session={
               props.flatDoc ? props.flatDoc[props.headlist.at(-1)].session : 0
            }
            blockID={props.block.id}
            sessionState={props.block.state}
         />
      </div>
   );
}
